import React from 'react';
import PropTypes from 'prop-types';
import { listingPropTypes } from '../../../utils/commonPropTypes';
import { EmailLeadForm } from '@dmm/lib-react-ui-components';
import { useBdpForm } from '../MainContent/bdpController/useBdpForm';
import { nil } from '../../../utils/runOnceHelper';
import { bdpFormMessages } from '../utils/bdpParsers';
import {syncTranslationElements} from '../../../tppServices/translations/intlManager';
import {useIntl} from 'react-intl';
import { getItem } from '../../../utils/storage';

const BDPEmailLeadForm = ({
  listing,
  portal,
  idPrefix,
  noShadow,
  lightBorder,
  onSuccess = nil,
  onError = nil,
  featureFlagMandatoryPhone,
  featureFlagQuestionnaire,
  overwriteDataTestId,
  shouldConvertCustomLeadHygieneGoal = false,
}) => {
  const intl = useIntl();
  const translator = syncTranslationElements(intl);
  const { messages, t } = translator;

  const { leadFormFields, leadFormHandlers, invalidFields, isDisabled, selectedCountry, flagsWithPrefix } = useBdpForm(
    listing,
    portal,
    translator,
    idPrefix,
    onSuccess,
    onError,
    featureFlagMandatoryPhone
  );

  const { sellerNameField, nameField, emailField, phoneField, textField } =
    leadFormFields;
  const { handleSubmit, showError } = leadFormHandlers;
  const emailFormMessages = bdpFormMessages(t, messages);
  const dataTestIdDiv = overwriteDataTestId ? overwriteDataTestId : 'email-lead-form';

  const isFormSubmitted = getItem(`formSubmitted-${listing.id}`) === 'true';

  const onSubmitLeadHygieneExperiment = () => {
    handleSubmit(shouldConvertCustomLeadHygieneGoal);
  };

  return (
    <>
      <div data-testid={dataTestIdDiv} className="email-lead-form">
        <EmailLeadForm
          id="emailLeadForm"
          sellerName={sellerNameField}
          name={nameField}
          email={emailField}
          phone={phoneField}
          textarea={textField}
          invalidFields={invalidFields}
          invalidMessage={`* ${t(messages.contactForm.formError)}`}
          buttonDisabled={isDisabled}
          classNames={{
            noShadow: noShadow,
            lightBorder: lightBorder,
            leadHygieneForm: true,
            phoneCountry: true,
            leadQualityForm: featureFlagQuestionnaire
          }}
          showSuccessMessage={isFormSubmitted}
          showErrorMessage={showError}
          onSubmit={onSubmitLeadHygieneExperiment}
          countries={flagsWithPrefix}
          countrySelected={selectedCountry}
          searchText={t(messages.contactForm.countrySearch)}
          noResultsText={t(messages.contactForm.countrySearchEmpty)}
          featureFlagMandatoryPhone={featureFlagMandatoryPhone}
          {...emailFormMessages}
        ></EmailLeadForm>
      </div>
    </>
  );
};

BDPEmailLeadForm.defaultProps = {
  listing: {},
  idPrefix: ''
};

BDPEmailLeadForm.propTypes = {
  listing: listingPropTypes,
  noShadow: PropTypes.bool,
  lightBorder: PropTypes.bool,
  idPrefix: PropTypes.string,
  portal: PropTypes.string,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  overwriteDataTestId: PropTypes.string,
  shouldConvertCustomLeadHygieneGoal: PropTypes.bool,
  featureFlagMandatoryPhone: PropTypes.bool,
  featureFlagQuestionnaire: PropTypes.bool
};

export default BDPEmailLeadForm;
